export const processNewPhoto = (ref, picture) => new Promise((resolve, reject) => {
    const formatted_picture_name = picture.name.replace(/[{('"`)}]/g, '')
    const ref_pic = ref.child(formatted_picture_name)

    ref_pic.getDownloadURL()
        .then( url =>  {
            const confirm = window.confirm(`Фото с названием ${picture.name} уже существует. Использовать существующее?\n\nНажмите: \nOK - чтобы использовать уже существующее; \nCANCEL - загрузить новое`)
            if (confirm) {
                const picture_data = {
                    name: formatted_picture_name,
                    url
                }
                resolve(picture_data)
            } else {

                function changeNameAndUploadPhoto (n) {
                    let new_name = `${n}-${formatted_picture_name}`
                    const ref_new_name = ref.child(new_name)

                    ref_new_name.getDownloadURL()
                        .then(()=> changeNameAndUploadPhoto(n+1) )
                        .catch( ()=> {
                            ref_new_name.put(picture).then(() => ref_new_name.getDownloadURL().then(url => {
                                const picture_data = {
                                    name: new_name,
                                    url
                                }
                                resolve(picture_data)
                            }))
                        })
                }

                changeNameAndUploadPhoto(1)

            }
        })
        .catch( ()=> {
            ref_pic.put(picture).then(() => ref_pic.getDownloadURL().then(url => {
                const picture_data = {
                    name: formatted_picture_name,
                    url
                }
                resolve(picture_data)
            }))
        })
})
